import React, { useEffect, createElement } from 'react';
import { SITE_IMAGES } from '../components/siteImages';
import { Page31HeroInfo } from './page31/Page31HeroInfo';
import { Page31HeroForm } from './page31/Page31HeroForm';
import { Page31TrialStrip } from './page31/Page31TrialStrip';
import { Page31Programs } from './page31/Page31Programs';
import { Page31Reviews } from './page31/Page31Reviews';
import { Page31Location } from './page31/Page31Location';
import { Page31FAQHeader } from './page31/Page31FAQHeader';
import { Page31FAQQuestions } from './page31/Page31FAQQuestions';
import { Page31RelatedLinks } from './page31/Page31RelatedLinks';
import { Page31FinalCTA } from './page31/Page31FinalCTA';
export function Page31() {
  useEffect(() => {
    document.title = 'Start a Trial at Storm Taekwondo | Farmington Hills, MI';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Start a trial class at Storm Taekwondo in Farmington Hills. Classes for kids, adults, and families. Ages 3+. Beginner-friendly. Contact us for current trial and enrollment options.';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2728">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2729">
        <div className="absolute inset-0 opacity-25" data-id="element-2730">
          <img src={SITE_IMAGES.heroHome} alt="Storm Taekwondo training in Farmington Hills" className="block w-full h-full object-cover" data-id="element-2731" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2732" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2733">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-2734">
            <Page31HeroInfo data-id="element-2735" />

            {/* SIGNUP FORM */}
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2736">
              <Page31HeroForm data-id="element-2737" />
            </div>
          </div>
        </div>
      </section>
      <Page31TrialStrip data-id="element-2738" />
      <Page31Programs data-id="element-2739" />
      <Page31Reviews data-id="element-2740" />
      <Page31Location data-id="element-2741" />
      <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2742">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2743">
          <Page31FAQHeader data-id="element-2744" />
          <Page31FAQQuestions data-id="element-2745" />
        </div>
      </section>
      <Page31RelatedLinks data-id="element-2746" />
      <Page31FinalCTA data-id="element-2747" />
    </div>;
}